import { Injectable, Inject } from '@angular/core';
import {
	FnCsvOption,
	FnCsvConfigDefaults,
	FnCsvConfigConsts,
	FnCsvHeader,
} from '../helpers/fn-csv.model';
import { isFloat } from '../util/check';

const hasOwnProperty = Object.prototype.hasOwnProperty;
const propIsEnumerable = Object.prototype.propertyIsEnumerable;

@Injectable()
export class FnCsvService {
	private _data: Array<any>;
	private _options: FnCsvOption;
	private csv = '';

	public generateCsv(
		data: Array<object>,
		@Inject('CsvOptions') options?: FnCsvOption
	):any {
		const config = options || {};
		this._data = typeof data !== 'object' ? JSON.parse(data) : data;
		// tslint:disable-next-line: no-use-before-declare
		this._options = this.objectAssign({}, FnCsvConfigDefaults, config);
		this.csv = '';
		if (this._options.useBom) {
			// tslint:disable-next-line: no-use-before-declare
			this.csv += FnCsvConfigConsts.BOM;
		}
		if (this._options.showTitle) {
			this.csv += this._options.title + '\r\n\n';
		}
		this.getHeaders();
		this.getBody();
		if (this.csv === '') {
			return '';
		}
		if (this._options.noDownload) {
			return this.csv;
		}
		const blob = new Blob([this.csv], { type: 'text/csv;charset=utf8;' });
		// if (navigator.msSaveBlob) {
		// 	const filename = this._options.filename.replace(/ /g, '_') + '.csv';
		// 	navigator.msSaveBlob(blob, filename);
		// } else
         {
			const uri = 'data:attachment/csv;charset=utf-8,' + encodeURI(this.csv);
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('visibility', 'hidden');
			link.download = this._options.filename.replace(/ /g, '_') + '.csv';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
         
	}

	private getHeaders(): void {
		let headers = [];
		if (this._options.headers.length > 0) {
			headers = this._options.headers;
		} else {
			headers = this.jsonsHeaders(this._data);
		}
		let row = headers.reduce((headerRow, header) => {
			return headerRow + '"' + header + '"' + this._options.fieldSeparator;
		}, '');
		row = row.slice(0, -1);
		// tslint:disable-next-line: no-use-before-declare
		this.csv += row + FnCsvConfigConsts.EOL;
	}

	private getBody() {
		let data = [];
		if (this._options.sortByKeys.length > 0) {
			const headers: string[] | FnCsvHeader[] = this._options.sortByKeys;
			const headerKeys: string[] = headers as string[];
			data = this._data.map((object:any) => {
				return headerKeys.map((header) => {
					return header in object ? object[header] : '';
				});
			});
		} else {
			data = this._data;
		}
		for (let i = 0; i < data.length; i++) {
			let row = '';
			// tslint:disable-next-line: forin
			for (const index in data[i]) {
				row += this.formartData(data[i][index]) + this._options.fieldSeparator;
			}
			row = row.slice(0, -1);
			// tslint:disable-next-line: no-use-before-declare
			this.csv += row + FnCsvConfigConsts.EOL;
		}
	}

	/**
	 * Format Data
	 */
	private formartData(data: any) {
		if (this._options.removeEmptyValues && !data) {
			return '';
		}
		if (this._options.decimalseparator === 'locale' && isFloat(data)) {
			return data.toLocaleString();
		}

		if (this._options.decimalseparator !== '.' && isFloat(data)) {
			return data.toString().replace('.', this._options.decimalseparator);
		}

		if (typeof data === 'string') {
			data = data.replace(/"/g, '""');
			if (
				this._options.quoteStrings ||
				data.indexOf(',') > -1 ||
				data.indexOf('\n') > -1 ||
				data.indexOf('\r') > -1
			) {
				data = this._options.quoteStrings + data + this._options.quoteStrings;
			}
			return data;
		}

		if (typeof data === 'boolean') {
			return data ? 'TRUE' : 'FALSE';
		}
		return data;
	}

	private jsonsHeaders(array: object[]) {
		return Array.from(
			new Set(
				array
					.map((item) => Object.keys(item))
					.reduce((a, b) => [...a, ...b], [])
			)
		);
	}

	private toObject(val: any) {
		if (val === null || val === undefined) {
			throw new TypeError(
				'Object.assign cannot be called with null or undefined'
			);
		}
		return Object(val);
	}

	private objectAssign(target: any, ...source: any[]) {
		let from: any;
		const to = this.toObject(target);
		let symbols: any;
		for (let s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
			for (const key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
			if ((Object as any).getOwnPropertySymbols) {
				symbols = (Object as any).getOwnPropertySymbols(from);
				for (let i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
		return to;
	}

	/**
	 * Get CSV String
	 */
	private getCsv() {
		return this.csv;
	}
}
